import React from 'react'
import { UrlApi } from '../../services/apirest'
import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";

function Tanquebuscar({ value, onChange }) {

    const [tanques, setTanques] = useState([]);
 // console.log("🛢 Tanquebuscar tanques", tanques);

  useEffect(() => {
    const fetchTanques = async () => {
      try {
        const res = await fetch(`${UrlApi}/vehiculos/patentetanque`);
        const data = await res.json();
        setTanques(data);
      } catch (error) {
        console.error("❌ Error al traer tanques", error);
      }
    };
    fetchTanques();
  }, []);


   return (
    <Autocomplete
      options={tanques}
      getOptionLabel={(option) =>
        option ? `Patente: ${option.patente}` : ""
      }
      value={tanques.find((t) => t.patente === value) || null}
      onChange={(e, newValue) => onChange(newValue ? newValue.patente : "")}
      renderInput={(params) => (
        <TextField {...params} label="Patente del tanque" fullWidth />
      )}
    />
  );
}

export default Tanquebuscar